
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 26 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.571 2.714H9.714v3.62h10.857v-3.62zm.905 8.143a.904.904 0 110-1.809.904.904 0 010 1.81zm-2.714 6.334h-7.239v-4.524h7.239v4.524zm2.714-9.953H8.809a2.714 2.714 0 00-2.714 2.714v5.429h3.619v3.62h10.857v-3.62h3.62V9.952a2.714 2.714 0 00-2.715-2.714z","fill":"#000","fill-opacity":".7"}}),_c('path',{attrs:{"d":"M5.095 19.3h.175l.086-.152-.26-.148.26.148h0l.001-.002.004-.007.016-.027.062-.11.25-.439 1-1.754c.888-1.56 2.223-3.899 4.005-7.015l.006-.011.005-.011.062-.133a.6.6 0 00-.034-.584c-.133-.207-.373-.307-.662-.307h-2.82l.856-5.991.049-.343H6.73l-.086.152-2.57 4.52c-1.078 1.893-1.96 3.442-2.644 4.651a.042.042 0 01-.001.002l-.01.014-.004.008-.01.017-.082.145a1.194 1.194 0 00-.123.3.623.623 0 00.015.366c.112.298.424.378.714.378h2.82l-.855 5.99-.05.343h1.251z","fill":"#0091EA","stroke":"#fff","stroke-width":".6"}})])
          )
        }
      }
    